import { useState, useEffect } from 'react'
import { strapiService } from '../services/strapiService'

export function useRelatedNews(currentNoticiaId?: number) {
  const [noticias, setNoticias] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchNoticias = async () => {
    try {
      setLoading(true)
      setError(null)
      
      const response = await strapiService.getNoticias()
      const noticiasData = response.data?.list_noticias || []
      
      setNoticias(noticiasData)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchNoticias()
  }, [currentNoticiaId]) // Adicionar currentNoticiaId como dependência

  return { 
    noticias, 
    loading, 
    error, 
    refetch: fetchNoticias 
  }
} 